import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[autoFocus]',
    standalone: false
})
export class AutofocusDirective implements OnChanges {
  @Input('autoFocus') shouldFocus: boolean | undefined;

  private isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['shouldFocus'] && this.shouldFocus && !this.isMobile) {
      this.el.nativeElement.focus({ preventScroll: true });
    }
  }
}